/* eslint-disable max-nested-callbacks */
// 共享文件以及我的文件子目录
import React, { useContext, useState, useEffect, useMemo, useCallback, useRef } from "react";
import api from "../../api";
import contextMenus, { Names } from "../../contextMenus";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import events from "../../context/events";
import TableList from "../../components/TableList";
import { ColumnsItem, JustifyContent } from "../../components/TableList/BaseComponents/Header";
import {
  getIconUrl,
  openLink,
  partialRefresh,
  time,
  isMySpace as isMySpaceCheck,
  checkJoyspaceError,
  removeDuplicate
} from "../../util";
import { changeEgovUrl } from "@/utils/tools";
import ContextMenu, { IContextRender } from "../../components/List/ContextMenu";
import { Icons } from "../../Icon";
import { message, Modal } from "antd";
import Tags, { TagType } from "../../components/Tags";
import context from "../../context";
import Filters from "../../components/List/Filters";
import { Order, Sort, timeFilter, titleFilter } from "../../components/List/Filters/config";
import BatchControl from "../../components/List/BatchControlNew";
import {
  folderType,
  folderTypeEnum,
  joyspacePermissionType
} from "../../config/permissions.config";
import batchOperate, { PageRouteName } from "../../batchOperate";
import { connect } from "dvajs";
import { JoyspaceState } from "@/models/joyspace";
import { useHistory } from "react-router-dom";
import ShareIcon from "../../components/List/ShareIcon";
import {
  ActionFnEnum,
  ActionType,
  ContextMenuMode,
  ErrorCode,
  FileType,
  MenusType,
  OpenFolderStatus
} from "../../types";
import { pageSize } from "../../config/basics.config";
import SyncStatusTag from "../../components/SyncStatusTag";
import { SyncStatusEunm } from "@/components/Joyspace/controllers/JoyspaceController";
import openDeleteModal from "../../contextModal/DeleteModal";
import openErrorDeleteModal from "../../contextModal/ErrorDeleteModal";
import ErrorMsg from "../../components/ErrorMsg";
import { PermissionEnum } from "../../const";
import UpdataService, { getFileInfo } from "../../reloadUtils";
import { useNavigator } from "@/utils/NetworkCheck";
import { useListData } from "../../components/TableList/Use/useListData";

// let params = {
//     srot: Sort.UpDateTime,
//     order: Order.DESC,
// };
let filterInfo: any = {
  srot: Sort.UpDateTime,
  order: Order.DESC
};
interface IProps {
  getFolderInfoById: Function;
  isShowFiles: boolean;
  _filterInfo: any;
  currentRouterInfo: any;
  diffHeight?: number;
  setCurrentRouterInfoById: Function;
  addFolderInfo: Function;
}
const key = MenusType.SPACE;
function PageList(props: IProps) {
  const { getFolderInfoById, currentRouterInfo, diffHeight = 0 } = props;
  const {
    list,
    setList,
    total,
    setTotal,
    loading,
    isLoadMore,
    setLoadMore,
    selecteds,
    select,
    onButtom,
    setPageIndex
  } = useListData({
    key,
    requestPagesFunc: api.pages.space,
    requestCategoriesuFunc: getFolderInfoById
  });
  const globalContext = useContext<GlobalContextConfig>(GlobalContext);
  const [defaultCheckedList, setDefaultCheckedList] = useState<string[]>([]);

  const [isMySpace, setIsMySpacePage] = useState<boolean>(false);
  const [defalutSpaceId, setDefalutSpaceId] = useState<folderType | null>(null);

  const history = useHistory();
  const { onLine } = globalContext;
  const [columns, setColumns] = useState<ColumnsItem[]>([
    {
      title: "",
      key: "title",
      dataIndex: "title",
      ellipsis: true,
      filters: true,
      render: () => (
        <Filters
          isArrowDownIcon={true}
          // onChange={(columnsItem: ColumnsItem) => {
          //     getListAll();
          // }}
          from={getPageRouteName()}
          menu={titleFilter()}
        />
      )
    },
    {
      title: "",
      key: "time",
      dataIndex: "time",
      width: "20%",
      style: {
        minWidth: "142px"
      },
      justifyContent: JustifyContent.Left,
      filters: true,
      render: () => <Filters from={getPageRouteName()} menu={timeFilter()} />
    },
    {
      title: "",
      key: "actions",
      dataIndex: "actions",
      actions: true,
      width: "10%",
      style: {
        minWidth: "30px"
      },
      justifyContent: JustifyContent.Center
    }
  ]);
  const getPageRouteName = () => {
    switch (currentRouterInfo?.type) {
      case folderTypeEnum.MY:
        return PageRouteName.MY_SPACE_FOLDER;
      case folderTypeEnum.SHARE:
        return PageRouteName.TEAM_SPACE_FOLDER;
      default:
        return PageRouteName.GROUP;
    }
  };
  useMemo(() => {
    let _columns = [...columns];
    const index = _columns.findIndex((item) => item.key === "checkbox");
    const item = _columns.filter((item) => item.filters);
    if (onLine && index === -1) {
      _columns.unshift({
        title: "",
        key: "checkbox",
        checkbox: true,
        dataIndex: "id",
        width: 30
      });
    } else if (!onLine && index !== -1) {
      _columns.splice(0, 1);
    }
    setColumns(_columns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);
  useEffect(() => {
    if (!currentRouterInfo) {
      console.warn("currentRouterInfo_null_Error");
      return;
    }
    setDefaultCheckedList([]);
    setIsMySpacePage(currentRouterInfo.type !== folderTypeEnum.SHARE);
    if (currentRouterInfo.type === folderTypeEnum.SHARE && defalutSpaceId !== folderType.SHARE) {
      setDefalutSpaceId(folderType.SHARE);
      return;
    }
    if (currentRouterInfo.type === folderTypeEnum.MY && defalutSpaceId !== folderType.MY) {
      setDefalutSpaceId(folderType.MY);
      return;
    }
  }, [currentRouterInfo, defalutSpaceId]);
  const openPage = (columnsItem: ColumnsItem, item: any) => {
    console.log(item.id, "openPageitem.id");
    // eslint-disable-next-line no-debugger
    if (!item.page_id) {
      const path = item.type === folderTypeEnum.SHARE ? `teamspace` : "myspace";
      history.push(`/joyspace/${path}?categoryId=${item.id}`);
      return;
    }
    if (!item.status) {
      openDeleteModal(FileType.Page, item.id);
      return;
    }
    if (item.syncStatus === SyncStatusEunm.PROCESS) {
      message.error("文档同步中，请同步完成后查看");
      return;
    }
    if (item.syncStatus === SyncStatusEunm.DATAERROR) {
      openErrorDeleteModal(item);
      return;
    }
    openLink(item, globalContext.appRuntimeEnv.joyspaceHost);
  };
  const getCheckedIds = (ids: string[] = []) => {
    const reslut = columns.find((item: ColumnsItem) => item.checkbox);
    if (!reslut) {
      return;
    }
    const _set = new Set();
    for (let id of ids) {
      for (let item of list) {
        if (item[reslut.dataIndex] === id) {
          _set.add(item);
        }
      }
    }
    select(_set);
  };
  const canDraggerUpload = useMemo(() => {
    if (useNavigator.onLine && currentRouterInfo) {
      if (currentRouterInfo.permissions) {
        return currentRouterInfo.permissions.includes(PermissionEnum.FOLDER_EDIT);
      } else if (currentRouterInfo.id !== "teamRoot") {
        return true;
      }
    }
    return false;
  }, [currentRouterInfo]);
  const setData = useCallback((data: any) => {
    console.log("setDatashan111", data);
    events.emit("list.partial.refresh", {
      changeData: data,
      key
    });
  }, []);
  useEffect(() => {
    events.on("table-setData", setData);
    return () => {
      events.off("table-setData", setData);
    };
  }, [setData]);
  const renderActions = useCallback(
    (item: any, contextMenuMode = ContextMenuMode.Click) => {
      return (
        <ContextMenu
          render={
            item.page_id
              ? contextMenus.page(
                  isMySpace ? "MY_SPACE" : "TEAM_SPACE",
                  globalContext,
                  currentRouterInfo
                )
              : contextMenus.category(isMySpace ? "MY_SPACE" : "TEAM_SPACE", currentRouterInfo)
          }
          callbackProps={{
            contextMenuMode,
            data: item,
            originId: currentRouterInfo?.id,
            setData,
            remove: () => {
              console.log("remove");
            },
            reload: () => {
              console.log("reload");
            }
          }}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentRouterInfo, globalContext, isMySpace, list, total]
  );

  return (
    <div className="joyspace-list-table joyspace-child-list">
      <TableList
        isLoadMore={isLoadMore}
        columns={columns}
        list={list}
        loading={loading}
        from={PageRouteName.MY_SPACE_PAGE}
        pagination={true}
        defaultCheckedList={defaultCheckedList}
        folderFrom={{
          folderId: currentRouterInfo?.id === "myspace" ? "" : currentRouterInfo?.id,
          fromName: currentRouterInfo?.name === "myspace" ? "" : currentRouterInfo?.name,
          canDraggerUpload,
          draggerUploadShow:
            currentRouterInfo?.name !== "myspace" && currentRouterInfo?.name !== "teamspace"
        }}
        isRoot={false}
        diffHeight={diffHeight}
        renderActions={renderActions}
        preOptions={(item, data, isExist) => {
          return (
            item.dataIndex === "title" &&
            (data.icon_url ? (
              <img
                src={
                  !isExist ? changeEgovUrl(data.icon_url) : getIconUrl(data.type || data.page_type)
                }
                data-icon
              />
            ) : (
              <ShareIcon isShared={data.isShared} />
            ))
          );
        }}
        afterOptions={(item, data) => {
          return (
            item.dataIndex === "title" && (
              <>
                {data.isCollected && <Tags left={5} TagType={TagType.Follow} />}
                {data.open === OpenFolderStatus.OPEN && <Tags left={5} TagType={TagType.Open} />}
              </>
            )
          );
        }}
        contentRender={(columnsItem: ColumnsItem, item: any) => {
          return (
            columnsItem.dataIndex === "time" &&
            item.isNew && <SyncStatusTag status={item.syncStatus} />
          );
        }}
        onButtom={onButtom}
        handleItem={openPage}
        getCheckedIds={getCheckedIds}
        footerHeight={50}
        allowDraggble={true}
        footerRender={() => {
          return (
            <BatchControl
              key={key}
              selecteds={selecteds as any}
              select={select}
              render={contextMenus.page(
                isMySpace ? "MY_SPACE" : "TEAM_SPACE",
                globalContext,
                currentRouterInfo
              )}
              categoryRender={contextMenus.category(
                isMySpace ? "MY_SPACE" : "TEAM_SPACE",
                currentRouterInfo
              )}
              callbackProps={{
                originId: currentRouterInfo?.id,
                setData: setData
              }}
              batchRender={batchOperate.batch(
                isMySpace ? "MY_SPACE" : "TEAM_SPACE",
                currentRouterInfo
              )}
              // type={isMySpace ? "MY_SPACE" : "TEAM_SPACE"}
            />
          );
        }}
      />
    </div>
  );
}

function mapStateToProps({ joyspace }: { joyspace: JoyspaceState }) {
  return {
    currentRouterInfo: joyspace.currentRouterInfo,
    _filterInfo: joyspace.filterInfo
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setCurrentRouterInfoById(data: any) {
      dispatch({ type: "joyspace/setCurrentRouterInfoById", payload: data });
    },
    getFolderInfoById(id: any, params: any) {
      return dispatch({
        type: "joyspace/freshFolderTreeById",
        payload: {
          id,
          params
        }
      });
    },
    addFolderInfo(list: any) {
      return dispatch({ type: "joyspace/addFolderInfo", payload: { list } });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(PageList);
